import axios from 'axios'
import qs from 'qs';


const API_PREFIX = "/api/article"
const WP_JSON = API_PREFIX + "/public/wp-json/wp/v2"

export const apiArticleByParams = params => {
    return axios.get(`${WP_JSON}/posts?${qs.stringify(params)}`)
}

export const apiTagsByTagName = tags => {
    return axios.get(`${WP_JSON}/tags?${qs.stringify({ search: tags })}`)
}

export const getPostByTagsId = (tagsId) => {
    return axios.get(`${WP_JSON}/posts?tags=${tagsId}`)
}

export const getPostByID = id => {
    return axios.get(`${WP_JSON}/posts?include=${id}`)
}